import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { SegmentPool_instance1wzn9b23peown as SegmentPool_instance } from './SegmentPool.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { arrayCopytctsywo3h7gj as arrayCopy } from '../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  toByte4i43936u611k as toByte,
  toShort36kaw0zjdq3ex as toShort,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.f4k_1 = 8192;
        this.g4k_1 = 1024;
      }
      h4k() {
        return Segment().i4k();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
function init_kotlinx_io_Segment(_this__u8e3s4) {
  _this__u8e3s4.f4i_1 = 0;
  _this__u8e3s4.g4i_1 = 0;
  _this__u8e3s4.h4i_1 = null;
  _this__u8e3s4.i4i_1 = false;
  _this__u8e3s4.j4i_1 = null;
  _this__u8e3s4.k4i_1 = null;
}
var SegmentClass;
function Segment() {
  if (SegmentClass === VOID) {
    class $ {
      k4j() {
        var tmp0_safe_receiver = this.h4i_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.j4k();
        return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
      }
      static i4k() {
        var $this = createThis(this);
        init_kotlinx_io_Segment($this);
        $this.e4i_1 = new Int8Array(8192);
        $this.i4i_1 = true;
        $this.h4i_1 = null;
        return $this;
      }
      static k4k(data, pos, limit, shareToken, owner) {
        var $this = createThis(this);
        init_kotlinx_io_Segment($this);
        $this.e4i_1 = data;
        $this.f4i_1 = pos;
        $this.g4i_1 = limit;
        $this.h4i_1 = shareToken;
        $this.i4i_1 = owner;
        return $this;
      }
      r4i() {
        var tmp0_elvis_lhs = this.h4i_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.also' call
          var this_0 = SegmentPool_instance.l4k();
          this.h4i_1 = this_0;
          tmp = this_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var t = tmp;
        var tmp_0 = this.f4i_1;
        var tmp_1 = this.g4i_1;
        // Inline function 'kotlin.also' call
        t.m4k();
        return Segment().k4k(this.e4i_1, tmp_0, tmp_1, t, false);
      }
      n4j() {
        var result = this.j4i_1;
        if (!(this.k4i_1 == null)) {
          ensureNotNull(this.k4i_1).j4i_1 = this.j4i_1;
        }
        if (!(this.j4i_1 == null)) {
          ensureNotNull(this.j4i_1).k4i_1 = this.k4i_1;
        }
        this.j4i_1 = null;
        this.k4i_1 = null;
        return result;
      }
      s4i(segment) {
        segment.k4i_1 = this;
        segment.j4i_1 = this.j4i_1;
        if (!(this.j4i_1 == null)) {
          ensureNotNull(this.j4i_1).k4i_1 = segment;
        }
        this.j4i_1 = segment;
        return segment;
      }
      l4j(byteCount) {
        // Inline function 'kotlin.require' call
        if (!(byteCount > 0 && byteCount <= (this.g4i_1 - this.f4i_1 | 0))) {
          var message = 'byteCount out of range';
          throw IllegalArgumentException().o2(toString(message));
        }
        var prefix;
        if (byteCount >= 1024) {
          prefix = this.r4i();
        } else {
          prefix = SegmentPool_instance.c3w();
          var tmp0 = this.e4i_1;
          var tmp2 = prefix.e4i_1;
          var tmp5 = this.f4i_1;
          // Inline function 'kotlin.collections.copyInto' call
          var endIndex = this.f4i_1 + byteCount | 0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp = tmp0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          arrayCopy(tmp, tmp2, 0, tmp5, endIndex);
        }
        prefix.g4i_1 = prefix.f4i_1 + byteCount | 0;
        this.f4i_1 = this.f4i_1 + byteCount | 0;
        if (!(this.k4i_1 == null)) {
          ensureNotNull(this.k4i_1).s4i(prefix);
        } else {
          prefix.j4i_1 = this;
          this.k4i_1 = prefix;
        }
        return prefix;
      }
      t4i() {
        // Inline function 'kotlin.check' call
        if (!!(this.k4i_1 == null)) {
          var message = 'cannot compact';
          throw IllegalStateException().o(toString(message));
        }
        if (!ensureNotNull(this.k4i_1).i4i_1)
          return this;
        var byteCount = this.g4i_1 - this.f4i_1 | 0;
        var availableByteCount = (8192 - ensureNotNull(this.k4i_1).g4i_1 | 0) + (ensureNotNull(this.k4i_1).k4j() ? 0 : ensureNotNull(this.k4i_1).f4i_1) | 0;
        if (byteCount > availableByteCount)
          return this;
        var predecessor = this.k4i_1;
        this.m4j(ensureNotNull(predecessor), byteCount);
        var successor = this.n4j();
        // Inline function 'kotlin.check' call
        if (!(successor == null)) {
          throw IllegalStateException().o('Check failed.');
        }
        SegmentPool_instance.u4j(this);
        return predecessor;
      }
      q4j(byte) {
        var _unary__edvuaz = this.g4i_1;
        this.g4i_1 = _unary__edvuaz + 1 | 0;
        this.e4i_1[_unary__edvuaz] = byte;
      }
      s4j(short) {
        var data = this.e4i_1;
        var limit = this.g4i_1;
        var _unary__edvuaz = limit;
        limit = _unary__edvuaz + 1 | 0;
        data[_unary__edvuaz] = toByte((short >>> 8 | 0) & 255);
        var _unary__edvuaz_0 = limit;
        limit = _unary__edvuaz_0 + 1 | 0;
        data[_unary__edvuaz_0] = toByte(short & 255);
        this.g4i_1 = limit;
      }
      m4i() {
        var _unary__edvuaz = this.f4i_1;
        this.f4i_1 = _unary__edvuaz + 1 | 0;
        return this.e4i_1[_unary__edvuaz];
      }
      o4i() {
        var data = this.e4i_1;
        var pos = this.f4i_1;
        var _unary__edvuaz = pos;
        pos = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlinx.io.and' call
        var tmp = (data[_unary__edvuaz] & 255) << 8;
        var _unary__edvuaz_0 = pos;
        pos = _unary__edvuaz_0 + 1 | 0;
        // Inline function 'kotlinx.io.and' call
        var tmp$ret$1 = data[_unary__edvuaz_0] & 255;
        var s = toShort(tmp | tmp$ret$1);
        this.f4i_1 = pos;
        return s;
      }
      m4j(sink, byteCount) {
        // Inline function 'kotlin.check' call
        if (!sink.i4i_1) {
          var message = 'only owner can write';
          throw IllegalStateException().o(toString(message));
        }
        if ((sink.g4i_1 + byteCount | 0) > 8192) {
          if (sink.k4j())
            throw IllegalArgumentException().ud();
          if (((sink.g4i_1 + byteCount | 0) - sink.f4i_1 | 0) > 8192)
            throw IllegalArgumentException().ud();
          var tmp0 = sink.e4i_1;
          var tmp2 = sink.e4i_1;
          var tmp5 = sink.f4i_1;
          // Inline function 'kotlin.collections.copyInto' call
          var endIndex = sink.g4i_1;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp = tmp0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          arrayCopy(tmp, tmp2, 0, tmp5, endIndex);
          sink.g4i_1 = sink.g4i_1 - sink.f4i_1 | 0;
          sink.f4i_1 = 0;
        }
        var tmp0_0 = this.e4i_1;
        var tmp2_0 = sink.e4i_1;
        var tmp4 = sink.g4i_1;
        var tmp6 = this.f4i_1;
        // Inline function 'kotlin.collections.copyInto' call
        var endIndex_0 = this.f4i_1 + byteCount | 0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_0 = tmp0_0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        arrayCopy(tmp_0, tmp2_0, tmp4, tmp6, endIndex_0);
        sink.g4i_1 = sink.g4i_1 + byteCount | 0;
        this.f4i_1 = this.f4i_1 + byteCount | 0;
      }
      x4i(dst, dstStartOffset, dstEndOffset) {
        var len = dstEndOffset - dstStartOffset | 0;
        var tmp0 = this.e4i_1;
        var tmp6 = this.f4i_1;
        // Inline function 'kotlin.collections.copyInto' call
        var endIndex = this.f4i_1 + len | 0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp = tmp0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        arrayCopy(tmp, dst, dstStartOffset, tmp6, endIndex);
        this.f4i_1 = this.f4i_1 + len | 0;
      }
      h4j(src, srcStartOffset, srcEndOffset) {
        var tmp2 = this.e4i_1;
        // Inline function 'kotlin.collections.copyInto' call
        var destinationOffset = this.g4i_1;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp = src;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        arrayCopy(tmp, tmp2, destinationOffset, srcStartOffset, srcEndOffset);
        this.g4i_1 = this.g4i_1 + (srcEndOffset - srcStartOffset | 0) | 0;
      }
      q2() {
        return this.g4i_1 - this.f4i_1 | 0;
      }
      g4j() {
        return this.e4i_1.length - this.g4i_1 | 0;
      }
      n4k(readOnly) {
        return this.e4i_1;
      }
      v4i(index) {
        return this.e4i_1[this.f4i_1 + index | 0];
      }
      o4k(index, value) {
        this.e4i_1[this.g4i_1 + index | 0] = value;
      }
      p4k(index, b0, b1) {
        var d = this.e4i_1;
        var l = this.g4i_1;
        d[l + index | 0] = b0;
        d[(l + index | 0) + 1 | 0] = b1;
      }
      q4k(index, b0, b1, b2) {
        var d = this.e4i_1;
        var l = this.g4i_1;
        d[l + index | 0] = b0;
        d[(l + index | 0) + 1 | 0] = b1;
        d[(l + index | 0) + 2 | 0] = b2;
      }
      r4k(index, b0, b1, b2, b3) {
        var d = this.e4i_1;
        var l = this.g4i_1;
        d[l + index | 0] = b0;
        d[(l + index | 0) + 1 | 0] = b1;
        d[(l + index | 0) + 2 | 0] = b2;
        d[(l + index | 0) + 3 | 0] = b3;
      }
    }
    initMetadataForClass($, 'Segment');
    SegmentClass = $;
  }
  return SegmentClass;
}
function isEmpty(_this__u8e3s4) {
  return _this__u8e3s4.q2() === 0;
}
var SegmentCopyTrackerClass;
function SegmentCopyTracker() {
  if (SegmentCopyTrackerClass === VOID) {
    class $ {}
    initMetadataForClass($, 'SegmentCopyTracker');
    SegmentCopyTrackerClass = $;
  }
  return SegmentCopyTrackerClass;
}
var AlwaysSharedCopyTrackerClass;
function AlwaysSharedCopyTracker() {
  if (AlwaysSharedCopyTrackerClass === VOID) {
    class $ extends SegmentCopyTracker() {
      constructor() {
        AlwaysSharedCopyTracker_instance = null;
        super();
        AlwaysSharedCopyTracker_instance = this;
      }
      j4k() {
        return true;
      }
      m4k() {
        return Unit_instance;
      }
    }
    initMetadataForObject($, 'AlwaysSharedCopyTracker');
    AlwaysSharedCopyTrackerClass = $;
  }
  return AlwaysSharedCopyTrackerClass;
}
var AlwaysSharedCopyTracker_instance;
function AlwaysSharedCopyTracker_getInstance() {
  if (AlwaysSharedCopyTracker_instance === VOID)
    new (AlwaysSharedCopyTracker())();
  return AlwaysSharedCopyTracker_instance;
}
function indexOf(_this__u8e3s4, byte, startOffset, endOffset) {
  // Inline function 'kotlin.require' call
  if (!(0 <= startOffset ? startOffset < _this__u8e3s4.q2() : false)) {
    var message = '' + startOffset;
    throw IllegalArgumentException().o2(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(startOffset <= endOffset ? endOffset <= _this__u8e3s4.q2() : false)) {
    var message_0 = '' + endOffset;
    throw IllegalArgumentException().o2(toString(message_0));
  }
  var p = _this__u8e3s4.f4i_1;
  var data = _this__u8e3s4.n4k(true);
  var inductionVariable = startOffset;
  if (inductionVariable < endOffset)
    do {
      var idx = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (data[p + idx | 0] === byte) {
        return idx;
      }
    }
     while (inductionVariable < endOffset);
  return -1;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  AlwaysSharedCopyTracker_getInstance as AlwaysSharedCopyTracker_getInstance98x6x1x3dodo,
  Companion_instance as Companion_instance9nc3ckjwxlpc,
  indexOf as indexOf1i2yqitz2lwb6,
  isEmpty as isEmpty39cntv762vey6,
};
//endregion

//# sourceMappingURL=Segment.mjs.map
